/**
 * Checks the platform origin against the environment allow-list.
 * Wildcards: subdomain (`https://*.pages.dev`) and, for local development only, any port (`http://localhost:*`).
 */
export function originAllowed(origin: string, allowed: readonly string[]): boolean {
  return allowed.some((a) => {
    if (a === origin) return true
    const port = a.match(/^(https?:\/\/(?:localhost|127\.0\.0\.1)):\*$/)
    if (port) return new RegExp('^' + port[1].replace(/\./g, '\\.') + ':\\d{1,5}$').test(origin)
    const m = a.match(/^(https?:\/\/)\*\.(.+)$/)
    if (!m) return false
    const [, scheme, host] = m
    return origin.startsWith(scheme) && origin.endsWith('.' + host) && !origin.slice(scheme.length).includes('/')
  })
}
